import { Content } from '@prismicio/client';
import { PrismicNextImage } from '@prismicio/next';
import { PrismicRichText, SliceComponentProps } from '@prismicio/react';
import { JSX } from 'react';
import styles from './index.module.scss';

export type PartnerInfoCardsProps =
  SliceComponentProps<Content.PartnerInfoCardsSlice>;

const PartnerInfoCards = ({ slice }: PartnerInfoCardsProps): JSX.Element => {
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={styles.wrapper}
    >
      <div className={styles.title}>
        <PrismicRichText field={slice.primary.title} />
      </div>
      <div className={styles.cardsWrapper}>
        {slice.primary.cards.map((el) => (
          <article className={styles.card} key={el.title}>
            <PrismicNextImage field={el.icon} className={styles.icon} />
            <p className={styles.cardTitle}>{el.title}</p>
            <p className={styles.cardSubtitle}>{el.text}</p>
          </article>
        ))}
      </div>
    </section>
  );
};

export default PartnerInfoCards;
